import type { FC } from 'react';
import React from 'react';

import { Field } from '../form-field';

import type { IProps } from './models';

/**
 * Компонент-хелпер.
 * Позволяет писать поля формы в React-Final-Form рекурсивно.
 */
export const Fields: FC<IProps> = ({
    // метаданные для каждого поля привязанные к его имени
    data = {},
    prev = [],
    fields: [name, ...rest],
    render,
    root = true,
    ...otherProps
}) => {
    return (
        <>
            {root &&
                [name, ...rest].map(fieldName => (
                    <Field<string>
                        key={fieldName}
                        data={data[fieldName]}
                        name={fieldName}
                        render={() => null}
                        {...otherProps}
                    />
                ))}
            <Field<string>
                data={data[name]}
                name={name}
                render={next =>
                    rest.length ? (
                        <Fields
                            data={data}
                            fields={rest}
                            prev={[...prev, next]}
                            render={render}
                            root={false}
                            {...otherProps}
                        />
                    ) : (
                        render(...prev, next)
                    )
                }
            />
        </>
    );
};
